import { MS_WHITE_LABEL_ID } from '../variables/GlobalVariables';

export function isWhiteLabel(): boolean {
  return (
    MS_WHITE_LABEL_ID !== 'HIFIVEWORK' && MS_WHITE_LABEL_ID !== 'AFRICAPAIERH'
  );
}
